import BetaModal from '@/components/admin/courses/BetaModal';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import useToggle from '@/data/hook/useToggle';
import CoursePath from '@/models/CoursePath';
import { CheckIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';

type Props = {
  coursePath: CoursePath;
};

export default function PushToBetaAction({ coursePath }: Props) {
  const { isOpen, toggle, close } = useToggle();

  const { t } = useTranslation('translation', {
    keyPrefix: 'courseBox.actions',
  });

  return (
    <Fragment>
      <BetaModal onClose={close} slug={coursePath.slug} visible={isOpen} />
      <MainButton
        text={t('putInBeta')}
        color="custom"
        onClick={toggle}
        className="font-500 !text-14 text-success gap-1 flex-row-reverse"
        icon={
          <CheckIcon
            className={'w-4 h-4 ease-in-out transition-all duration-200'}
            strokeWidth={3}
          />
        }
      />
    </Fragment>
  );
}
